export const classCategories = [
  { id: "all", label: "전체" },
  { id: "image", label: "이미지·이모티콘" },
  { id: "writing", label: "콘텐츠 수익화" },
  { id: "video", label: "숏폼·영상" },
  { id: "business", label: "칼퇴 자동화" },
  { id: "dev", label: "SaaS·개발" },
];

export const exploreClasses = [
  {
    id: 1,
    category: "image",
    title: "미드저니로 이모티콘 팔아 월 수익 만들기",
    desc: "카카오·라인 이모티콘 승인받고 자는 동안 연금처럼 수익 받는 법",
    icon: "ri-palette-line",
    iconBg: "#FFF3E0",
    iconColor: "#FF8C00",
    participants: 1200,
    level: "입문",
    duration: "2시간",
    lessons: 3,
    tag: "💸 수익화",
    image: "https://public.readdy.ai/ai/img_res/d24864abb8b1c29bff2f1ccd98477f67.jpg",
  },
  {
    id: 2,
    category: "business",
    title: "퇴근 2시간 앞당기는 AI 자동화 세팅",
    desc: "보고서·이메일·회의록을 ChatGPT에게 떠넘기는 실무 프롬프트 완성",
    icon: "ri-timer-flash-line",
    iconBg: "#E8F5E9",
    iconColor: "#00D873",
    participants: 980,
    level: "중급",
    duration: "3시간",
    lessons: 4,
    tag: "⏰ 칼퇴",
    image: "https://readdy.ai/api/search-image?query=modern%20office%20automation%20workflow%20diagram%20arrows%20clean%20minimal%20business%20productivity%20dashboard%20white%20background%20tech%20illustration%20flat%20design&width=400&height=260&seq=ex2&orientation=landscape",
  },
  {
    id: 3,
    category: "writing",
    title: "AI 쇼츠 스크립트로 수익화 조건 달성",
    desc: "조회수 10만 터지는 쇼츠 스크립트를 AI와 10분에 뽑는 공식",
    icon: "ri-video-line",
    iconBg: "#FCE4EC",
    iconColor: "#E91E63",
    participants: 750,
    level: "입문",
    duration: "1.5시간",
    lessons: 3,
    tag: "🎬 수익화",
    image: "https://readdy.ai/api/search-image?query=creative%20content%20creator%20writing%20script%20notebook%20laptop%20warm%20desk%20light%20minimal%20clean%20modern%20young%20aesthetic&width=400&height=260&seq=ex3&orientation=landscape",
  },
  {
    id: 4,
    category: "image",
    title: "AI 그림으로 스톡사이트 달러 수익 시작",
    desc: "Shutterstock·Adobe Stock에 AI 이미지 올려서 매달 달러 버는 완전 가이드",
    icon: "ri-camera-3-line",
    iconBg: "#EDE7F6",
    iconColor: "#7C3AED",
    participants: 2100,
    level: "고급",
    duration: "4시간",
    lessons: 6,
    tag: "💵 달러 수익",
    image: "https://readdy.ai/api/search-image?query=cinematic%20ai%20generated%20landscape%20dramatic%20lighting%20fantasy%20world%20beautiful%20vivid%20colors%20artistic%20stunning%20digital%20painting%20wide%20clean%20minimal%20background&width=400&height=260&seq=ex4&orientation=landscape",
  },
  {
    id: 5,
    category: "dev",
    title: "GPT 챗봇 만들어 SaaS처럼 판매하기",
    desc: "코딩 초보도 만드는 나만의 AI 서비스, 월 구독료 받는 법까지",
    icon: "ri-robot-2-line",
    iconBg: "#E3F2FD",
    iconColor: "#0284C7",
    participants: 640,
    level: "중급",
    duration: "3.5시간",
    lessons: 5,
    tag: "🚀 SaaS",
    image: "https://readdy.ai/api/search-image?query=chatbot%20interface%20screen%20modern%20UI%20design%20clean%20minimal%20chat%20bubble%20conversation%20white%20background%20tech%20illustration%20flat%20design&width=400&height=260&seq=ex5&orientation=landscape",
  },
  {
    id: 6,
    category: "video",
    title: "AI 숏폼으로 월 수익 창출 조건 달성",
    desc: "런웨이+캡컷으로 릴스/쇼츠 제작하고 수익화까지 연결하는 전 과정",
    icon: "ri-movie-2-line",
    iconBg: "#FFF9C4",
    iconColor: "#F9A825",
    participants: 1560,
    level: "입문",
    duration: "2.5시간",
    lessons: 4,
    tag: "📱 쇼츠 수익",
    image: "https://readdy.ai/api/search-image?query=short%20form%20video%20content%20creation%20phone%20screen%20reel%20tiktok%20modern%20aesthetic%20young%20creator%20minimal%20clean%20background%20vibrant%20colors&width=400&height=260&seq=ex6&orientation=landscape",
  },
  {
    id: 7,
    category: "writing",
    title: "AI 카피로 전환율 올리고 부업 수주하기",
    desc: "클라이언트 전환율 3배 올리는 카피라이팅 프롬프트로 외주 단가 높이기",
    icon: "ri-edit-2-line",
    iconBg: "#F3E5F5",
    iconColor: "#9333EA",
    participants: 430,
    level: "중급",
    duration: "2시간",
    lessons: 3,
    tag: "✍️ 외주 수익",
    image: "https://readdy.ai/api/search-image?query=copywriting%20marketing%20text%20advertisement%20modern%20clean%20minimal%20billboard%20poster%20design%20white%20background%20professional%20flat%20illustration&width=400&height=260&seq=ex7&orientation=landscape",
  },
  {
    id: 8,
    category: "business",
    title: "10분 PT로 칼퇴 + 클라이언트 WOW",
    desc: "감마·톰으로 10분 만에 전문 PT 완성, 야근 없애는 업무 루틴 세팅",
    icon: "ri-bar-chart-2-line",
    iconBg: "#E8F5E9",
    iconColor: "#2E7D32",
    participants: 870,
    level: "입문",
    duration: "1시간",
    lessons: 2,
    tag: "📊 칼퇴",
    image: "https://readdy.ai/api/search-image?query=business%20presentation%20slide%20deck%20modern%20clean%20design%20data%20chart%20graph%20white%20background%20professional%20minimal%20corporate%20flat%20illustration&width=400&height=260&seq=ex8&orientation=landscape",
  },
];

export const feedPosts = [
  {
    id: 1,
    user: { name: "김지우", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20casual%20portrait%20clean%20white%20background%20minimal%20photography%20headshot&width=60&height=60&seq=f1&orientation=squarish" },
    challenge: "미드저니로 이모티콘 팔아 월 수익 만들기",
    prompt: "A cute pastel character holding a coffee cup, sticker design style, white background, kawaii --ar 1:1 --v 6",
    image: "https://readdy.ai/api/search-image?query=kawaii%20cute%20pastel%20character%20sticker%20design%20coffee%20cup%20white%20background%20adorable%20illustration%20flat%20minimal%20clean%20art&width=320&height=400&seq=fd1&orientation=portrait",
    likes: 142,
    comments: 23,
    claps: 89,
    height: "tall",
  },
  {
    id: 2,
    user: { name: "박준혁", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20casual%20portrait%20clean%20white%20background%20minimal%20photography%20headshot&width=60&height=60&seq=f2&orientation=squarish" },
    challenge: "AI 숏폼으로 수익 창출",
    prompt: "cinematic sunset timelapse of Seoul city, golden hour, drone view, ultra realistic --ar 16:9",
    image: "https://readdy.ai/api/search-image?query=cinematic%20seoul%20korea%20city%20sunset%20golden%20hour%20aerial%20drone%20view%20dramatic%20lighting%20beautiful%20realistic%20photography%20skyline&width=320&height=300&seq=fd2&orientation=landscape",
    likes: 98,
    comments: 15,
    claps: 67,
    height: "medium",
  },
  {
    id: 3,
    user: { name: "이소연", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20smile%20portrait%20minimal%20background%20headshot%20photography%20clean&width=60&height=60&seq=f3&orientation=squarish" },
    challenge: "AI 그림으로 스톡사이트 수익",
    prompt: "ethereal forest with glowing mushrooms and fireflies, fantasy illustration, watercolor style, pastel dream --v 6",
    image: "https://readdy.ai/api/search-image?query=enchanted%20fantasy%20forest%20glowing%20mushrooms%20fireflies%20magical%20watercolor%20pastel%20dream%20ethereal%20beautiful%20illustration%20art&width=320&height=420&seq=fd3&orientation=portrait",
    likes: 215,
    comments: 41,
    claps: 156,
    height: "tall",
  },
  {
    id: 4,
    user: { name: "최민재", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20professional%20casual%20portrait%20minimal%20clean%20background%20headshot%20photography&width=60&height=60&seq=f4&orientation=squarish" },
    challenge: "퇴근 2시간 앞당기는 AI 자동화",
    prompt: "Act as a professional report writer. Summarize weekly marketing activities in Korean, bullet points, under 200 words.",
    image: null,
    text: "주간 보고서 자동화 완성! 매주 2시간 걸리던 작업이 10분으로 줄었어요. 이번 달만 벌써 8시간 절약 💚 이 프롬프트 하나로 매일 칼퇴 중입니다",
    likes: 87,
    comments: 32,
    claps: 54,
    height: "short",
  },
  {
    id: 5,
    user: { name: "강하윤", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20bright%20smile%20casual%20portrait%20clean%20white%20background%20minimal%20photography%20headshot&width=60&height=60&seq=f5&orientation=squarish" },
    challenge: "GPT 챗봇 만들어 SaaS 판매",
    prompt: "Build a customer service chatbot for a cafe. Respond in Korean, be friendly and helpful, know our menu items",
    image: "https://readdy.ai/api/search-image?query=cafe%20chatbot%20app%20interface%20mobile%20screen%20modern%20clean%20minimal%20design%20korean%20coffee%20shop%20chat%20UI&width=320&height=380&seq=fd5&orientation=portrait",
    likes: 163,
    comments: 28,
    claps: 112,
    height: "tall",
  },
  {
    id: 6,
    user: { name: "윤서준", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20smile%20portrait%20clean%20background%20minimal%20headshot%20photography&width=60&height=60&seq=f6&orientation=squarish" },
    challenge: "AI 카피로 외주 수주하기",
    prompt: "Write a compelling Instagram caption for a skincare brand targeting Gen Z. Natural ingredients, playful and bold tone.",
    image: null,
    text: "AI 카피라이팅으로 인스타 광고 CTR 3배 올려줬더니 클라이언트가 월 계약으로 전환해줬어요 💸 월 부업 수입 +45만원 달성!",
    likes: 201,
    comments: 45,
    claps: 178,
    height: "short",
  },
  {
    id: 7,
    user: { name: "임나영", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20creative%20casual%20portrait%20minimal%20clean%20background%20headshot%20photography&width=60&height=60&seq=f7&orientation=squarish" },
    challenge: "미드저니 이모티콘 수익화",
    prompt: "tote bag mockup design, minimalist botanical illustration, sage green and cream, eco-friendly brand vibe --ar 3:4",
    image: "https://readdy.ai/api/search-image?query=tote%20bag%20mockup%20minimalist%20botanical%20illustration%20sage%20green%20cream%20eco%20friendly%20brand%20clean%20white%20background%20flat%20lay%20product&width=320&height=400&seq=fd7&orientation=portrait",
    likes: 328,
    comments: 67,
    claps: 245,
    height: "tall",
  },
];
